const ratingColors = {
	primary: "#52BFF4",
	default: "#FFF50D",
};

export default ratingColors;
